export interface StaticTranslateKey {
  ___: string;
  defaultText: string;
}
/**
 * This function should only be used for static strings. Never input anything into the key parameter that isn't a plain string.
 */
export const createStaticTranslateKey = (defaultText: string, key: string) => {
  return { ___: key, defaultText } as StaticTranslateKey;
};
